import { CanActivateFn } from '@angular/router';

import { AuthService } from '../../auth/services/auth.service';
import { RedirectService } from '../services/redirect.service';
import { StorageService } from '../services/storage.service';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const redirect = inject(RedirectService);
  const storageService = inject(StorageService);

  const queryString = state.url.split('?')[1] || '';
  const params = new URLSearchParams(queryString);
  const token = params.get('token');
  const currentToken = storageService.getToken();

  if (token && authService.isLoggedIn()) {
    if (token !== currentToken) {
      storageService.setToken(token);
      return authService.getUserData();
    }

    redirect.redirectToCurrentRouteWithoutQueryParams();
    return true;
  }

  if (token && !authService.isLoggedIn()) {
    storageService.setToken(token);
    return authService.getUserData(window.location.href);
  }

  if (!token && !authService.isLoggedIn()) {
    authService.logout(window.location.href);
    return false;
  }

  return true;
};
